import { Instance } from '../../types';

type MeasurementEntry = [string, string];

type Measurements = {
    [key: string]: MeasurementEntry[];
};

type TimeValue = {
    time: string;
    value: number | null;
};

type Results = {
    [category: string]: {
        [measurement: string]: TimeValue[];
    };
};

type TimeRange = {
    start: string;
    stop: string;
    labels: string[];
};

type EnergyData = {
    instance: Instance;
    measurements: Measurements;
    results: Results;
    time_range: TimeRange;
};

export enum TimePeriod {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year'
}

export enum Resolution {
    Mins = '15m',   
    Hour = '1h',
    Day = '1d',
    Week = '1w',
    Month = '1mo',
    Year = '1y',
}

export type { EnergyData };